"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalNbTransactions = exports.getTotalValue = exports.getPoolOrderInfos = exports.getPoolOrdersInfosFromSignature = exports.parseSettleInstruction = exports.parseCreateOrderInstruction = exports.getPoolTokenMintFromSeed = exports.getPoolsSeedsBySigProvider = exports.singleTokenDeposit = exports.fetchPoolBalances = exports.fetchPoolInfo = exports.settlePool = void 0;
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const serum_1 = require("@project-serum/serum");
const instructions_1 = require("./instructions");
const utils_1 = require("./utils");
const state_1 = require("./state");
const main_1 = require("./main");
const bs58_1 = __importDefault(require("bs58"));
const market_1 = require("@project-serum/serum/lib/market");
const bs58_2 = __importDefault(require("bs58"));
// TODO singleTokenDeposit optim + singleTokenRedeem
/**
 * Returns the solana instructions to settle all open orders for a given pool.
 * If the returned transaction array is too large for it to be sent on Solana,
 * you may need to process it batch-wise.
 *
 * @param connection
 * @param poolSeed
 */
async function settlePool(connection, poolSeed, srmRefWallet = null) {
    let poolKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed], main_1.BONFIDABOT_PROGRAM_ID);
    let array_one = new Uint8Array(1);
    array_one[0] = 1;
    let poolData = await connection.getAccountInfo(poolKey);
    if (!poolData) {
        throw 'Pool account is unavailable';
    }
    let poolHeader = state_1.PoolHeader.fromBuffer(poolData.data.slice(0, state_1.PoolHeader.LEN));
    let authorizedMarkets = state_1.unpack_markets(poolData.data.slice(state_1.PoolHeader.LEN, state_1.PoolHeader.LEN + Number(poolHeader.numberOfMarkets) * state_1.PUBKEY_LENGTH), poolHeader.numberOfMarkets);
    let instructions = [];
    for (let authorizedMarket of authorizedMarkets) {
        const market = await serum_1.Market.load(connection, authorizedMarket, {}, main_1.SERUM_PROGRAM_ID);
        const openOrdersAccounts = await market.findOpenOrdersAccountsForOwner(connection, poolKey);
        console.log(openOrdersAccounts.length);
        for (let openOrder of openOrdersAccounts) {
            if (!openOrder.quoteTokenFree.toNumber() &&
                !openOrder.baseTokenFree.toNumber()) {
                continue;
            }
            instructions.push((await main_1.settleFunds(connection, poolSeed, authorizedMarket, openOrder.address, srmRefWallet))[0]);
        }
    }
    return instructions;
}
exports.settlePool = settlePool;
/**
 * Returns a structure containing most informations that one can parse from a pools state.
 * @param connection
 * @param poolSeed
 */
async function fetchPoolInfo(connection, poolSeed) {
    let poolKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed], main_1.BONFIDABOT_PROGRAM_ID);
    let array_one = new Uint8Array(1);
    array_one[0] = 1;
    let poolMintKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed, array_one], main_1.BONFIDABOT_PROGRAM_ID);
    let poolData = await connection.getAccountInfo(poolKey);
    if (!poolData) {
        throw 'Pool account is unavailable';
    }
    let poolHeader = state_1.PoolHeader.fromBuffer(poolData.data.slice(0, state_1.PoolHeader.LEN));
    let poolAssets = state_1.unpack_assets(poolData.data.slice(state_1.PoolHeader.LEN + Number(poolHeader.numberOfMarkets) * state_1.PUBKEY_LENGTH));
    let authorizedMarkets = state_1.unpack_markets(poolData.data.slice(state_1.PoolHeader.LEN, state_1.PoolHeader.LEN + Number(poolHeader.numberOfMarkets) * state_1.PUBKEY_LENGTH), poolHeader.numberOfMarkets);
    let poolInfo = {
        address: poolKey,
        serumProgramId: poolHeader.serumProgramId,
        seed: poolHeader.seed,
        signalProvider: poolHeader.signalProvider,
        status: poolHeader.status,
        feeRatio: poolHeader.feeRatio,
        feePeriod: poolHeader.feeCollectionPeriod,
        mintKey: poolMintKey,
        assetMintkeys: poolAssets.map(asset => asset.mintAddress),
        authorizedMarkets,
    };
    return poolInfo;
}
exports.fetchPoolInfo = fetchPoolInfo;
/**
 * Fetch the balances of the poolToken and the assets (returned in the same order as in the poolData)
 *
 * @param connection
 * @param poolSeed
 */
async function fetchPoolBalances(connection, poolSeed) {
    let poolKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed], main_1.BONFIDABOT_PROGRAM_ID);
    let array_one = new Uint8Array(1);
    array_one[0] = 1;
    let poolMintKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed, array_one], main_1.BONFIDABOT_PROGRAM_ID);
    let poolData = await connection.getAccountInfo(poolKey);
    if (!poolData) {
        throw 'Pool account is unavailable';
    }
    let poolHeader = state_1.PoolHeader.fromBuffer(poolData.data.slice(0, state_1.PoolHeader.LEN));
    let poolAssets = state_1.unpack_assets(poolData.data.slice(state_1.PoolHeader.LEN + Number(poolHeader.numberOfMarkets) * state_1.PUBKEY_LENGTH));
    let assetBalances = [];
    for (let asset of poolAssets) {
        let assetKey = await utils_1.findAssociatedTokenAddress(poolKey, asset.mintAddress);
        let balance = (await connection.getTokenAccountBalance(assetKey)).value;
        assetBalances.push({
            tokenAmount: balance,
            mint: asset.mintAddress.toBase58(),
        });
    }
    let poolTokenSupply = (await connection.getTokenSupply(poolMintKey)).value;
    return [poolTokenSupply, assetBalances];
}
exports.fetchPoolBalances = fetchPoolBalances;
/**
 * This method lets the user deposit an arbitrary token into the pool
 * by intermediately trading with serum in order to reach the pool asset ratio.
 * (WIP)
 *
 * @param connection
 * @param sourceOwner
 * @param sourceTokenKey
 * @param user_amount
 * @param poolSeed
 * @param payer
 */
async function singleTokenDeposit(connection, sourceOwner, sourceTokenKey, 
// The amount of source tokens to invest into pool
user_amount, poolSeed, payer) {
    // Fetch Poolasset mints
    console.log('Creating source asset accounts');
    let poolKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed], main_1.BONFIDABOT_PROGRAM_ID);
    let array_one = new Uint8Array(1);
    array_one[0] = 1;
    let poolMintKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed, array_one], main_1.BONFIDABOT_PROGRAM_ID);
    let poolInfo = await connection.getAccountInfo(poolKey);
    if (!poolInfo) {
        throw 'Pool account is unavailable';
    }
    let poolHeader = state_1.PoolHeader.fromBuffer(poolInfo.data.slice(0, state_1.PoolHeader.LEN));
    let poolAssets = state_1.unpack_assets(poolInfo.data.slice(state_1.PoolHeader.LEN + Number(poolHeader.numberOfMarkets) * state_1.PUBKEY_LENGTH));
    // Transfer source tokens to USDC
    let tokenInfo = await connection.getAccountInfo(sourceTokenKey);
    if (!tokenInfo) {
        throw 'Source asset account is unavailable';
    }
    let tokenData = Buffer.from(tokenInfo.data);
    const tokenMint = new web3_js_1.PublicKey(spl_token_1.AccountLayout.decode(tokenData).mint);
    const tokenInitialBalance = spl_token_1.AccountLayout.decode(tokenData).amount;
    let tokenSymbol = serum_1.TOKEN_MINTS[serum_1.TOKEN_MINTS.map(t => t.address.toString()).indexOf(tokenMint.toString())].name;
    let precision = await (await connection.getTokenAccountBalance(sourceTokenKey)).value.decimals;
    let amount = precision * user_amount;
    let midPriceUSDC, sourceUSDCKey;
    if (tokenSymbol != 'USDC') {
        let pairSymbol = tokenSymbol.concat('/USDC');
        let usdcMarketInfo = serum_1.MARKETS[serum_1.MARKETS.map(m => {
            return m.name;
        }).lastIndexOf(pairSymbol)];
        if (usdcMarketInfo.deprecated) {
            throw 'Chosen Market is deprecated';
        }
        let marketUSDC;
        [marketUSDC, midPriceUSDC] = await utils_1.getMidPrice(connection, usdcMarketInfo.address);
        console.log(tokenInitialBalance);
        console.log('Creating token to USDC order');
        console.log({
            owner: sourceOwner.publicKey.toString(),
            payer: sourceTokenKey.toString(),
            side: 'sell',
            price: 0.95 * midPriceUSDC,
            size: amount,
            orderType: 'ioc',
        });
        await marketUSDC.placeOrder(connection, {
            owner: sourceOwner,
            payer: sourceTokenKey,
            side: 'sell',
            price: 0.95 * midPriceUSDC,
            size: amount,
            orderType: 'ioc',
        });
        sourceUSDCKey = await utils_1.findAssociatedTokenAddress(sourceOwner.publicKey, marketUSDC.quoteMintAddress);
        let sourceUSDCInfo = await connection.getAccountInfo(sourceUSDCKey);
        if (!sourceUSDCInfo) {
            let createUSDCInstruction = await utils_1.createAssociatedTokenAccount(web3_js_1.SystemProgram.programId, payer.publicKey, sourceOwner.publicKey, marketUSDC.quoteMintAddress);
            await utils_1.signAndSendTransactionInstructions(connection, [], payer, [
                createUSDCInstruction,
            ]);
        }
        // Wait for the Serum Event Queue to be processed
        await utils_1.sleep(3 * 1000);
        // Settle the sourceToken to USDC transfer
        console.log('Settling order');
        let openOrders = await marketUSDC.findOpenOrdersAccountsForOwner(connection, sourceOwner.publicKey);
        for (let openOrder of openOrders) {
            await marketUSDC.settleFunds(connection, sourceOwner, openOrder, sourceTokenKey, sourceUSDCKey);
        }
    }
    else {
        midPriceUSDC = 1;
        sourceUSDCKey = sourceTokenKey;
    }
    // Verify that order went through correctly
    tokenInfo = await connection.getAccountInfo(sourceTokenKey);
    if (!tokenInfo) {
        throw 'Source asset account is unavailable';
    }
    tokenData = Buffer.from(tokenInfo.data);
    let tokenBalance = spl_token_1.AccountLayout.decode(tokenData).amount;
    if (tokenInitialBalance - tokenBalance > amount) {
        throw 'Conversion to USDC Order was not matched.';
    }
    // Create the source asset account if nonexistent
    let createAssetInstructions = new Array();
    let sourceAssetKeys = [];
    let poolAssetKeys = [];
    for (let asset of poolAssets) {
        let sourceAssetKey = await utils_1.findAssociatedTokenAddress(sourceOwner.publicKey, asset.mintAddress);
        sourceAssetKeys.push(sourceAssetKey);
        let poolAssetKey = await utils_1.findAssociatedTokenAddress(poolKey, asset.mintAddress);
        poolAssetKeys.push(poolAssetKey);
        let sourceAssetInfo = await connection.getAccountInfo(sourceAssetKey);
        if (!sourceAssetInfo) {
            createAssetInstructions.push(await utils_1.createAssociatedTokenAccount(web3_js_1.SystemProgram.programId, payer.publicKey, sourceOwner.publicKey, asset.mintAddress));
        }
    }
    if (createAssetInstructions.length > 0) {
        await utils_1.signAndSendTransactionInstructions(connection, [], payer, createAssetInstructions);
    }
    // Buy the corresponding tokens with the source USDC in correct ratios
    console.log('Invest USDC in pool ratios');
    let totalPoolAssetAmount = 0;
    let poolAssetAmounts = [];
    for (let asset of poolAssets) {
        let poolAssetKey = await utils_1.findAssociatedTokenAddress(poolKey, asset.mintAddress);
        let poolAssetBalance = +(await connection.getTokenAccountBalance(poolAssetKey)).value.amount;
        poolAssetAmounts.push(poolAssetBalance);
        totalPoolAssetAmount += poolAssetBalance;
    }
    let poolAssetMarkets = [];
    let poolTokenAmount = 0;
    for (let i = 0; i < poolAssets.length; i++) {
        let poolAssetSymbol = serum_1.TOKEN_MINTS[serum_1.TOKEN_MINTS.map(t => t.address.toString()).indexOf(poolAssets[i].mintAddress.toString())].name;
        if (poolAssetSymbol != 'USDC') {
            let assetPairSymbol = poolAssetSymbol.concat('/USDC');
            let assetMarketInfo = serum_1.MARKETS[serum_1.MARKETS.map(m => {
                return m.name;
            }).lastIndexOf(assetPairSymbol)];
            if (assetMarketInfo.deprecated) {
                throw 'Chosen Market is deprecated';
            }
            if (poolAssetAmounts[i] == 0) {
                continue;
            }
            let [assetMarket, assetMidPrice] = await utils_1.getMidPrice(connection, assetMarketInfo.address);
            poolAssetMarkets.push(assetMarket);
            let assetAmountToBuy = (midPriceUSDC * amount * poolAssetAmounts[i]) /
                (assetMidPrice * totalPoolAssetAmount);
            poolTokenAmount = Math.max(poolTokenAmount, assetAmountToBuy / poolAssetAmounts[i]);
            console.log(assetPairSymbol);
            console.log({
                owner: sourceOwner.publicKey.toString(),
                payer: sourceUSDCKey.toString(),
                side: 'buy',
                price: 1.05 * assetMidPrice,
                size: assetAmountToBuy,
                orderType: 'ioc',
            });
            await assetMarket.placeOrder(connection, {
                owner: sourceOwner,
                payer: sourceUSDCKey,
                side: 'buy',
                price: 1.05 * assetMidPrice,
                size: assetAmountToBuy,
                orderType: 'ioc',
            });
        }
        else {
            poolAssetMarkets.push(undefined);
            poolTokenAmount = Math.max(poolTokenAmount, (1000000 * midPriceUSDC * amount) / totalPoolAssetAmount);
        }
    }
    // Wait for the Serum Event Queue to be processed
    await utils_1.sleep(3 * 1000);
    // Settle the USDC to Poolassets transfers
    console.log('Settling the orders');
    for (let i = 0; i < poolAssets.length; i++) {
        let assetMarket = poolAssetMarkets[i];
        if (!!assetMarket) {
            let openOrders = await assetMarket.findOpenOrdersAccountsForOwner(connection, sourceOwner.publicKey);
            for (let openOrder of openOrders) {
                await assetMarket.settleFunds(connection, sourceOwner, openOrder, sourceAssetKeys[i], sourceUSDCKey);
            }
        }
    }
    // If nonexistent, create the source owner and signal provider associated addresses to receive the pooltokens
    let instructions = [];
    let [targetPoolTokenKey, targetPTInstruction,] = await utils_1.findAndCreateAssociatedAccount(web3_js_1.SystemProgram.programId, connection, sourceOwner.publicKey, poolMintKey, payer.publicKey);
    targetPTInstruction ? instructions.push(targetPTInstruction) : null;
    let [sigProviderFeeReceiverKey, sigProvInstruction,] = await utils_1.findAndCreateAssociatedAccount(web3_js_1.SystemProgram.programId, connection, poolHeader.signalProvider, poolMintKey, payer.publicKey);
    sigProvInstruction ? instructions.push(sigProvInstruction) : null;
    let [bonfidaFeeReceiverKey, bonfidaFeeInstruction,] = await utils_1.findAndCreateAssociatedAccount(web3_js_1.SystemProgram.programId, connection, main_1.BONFIDA_FEE_KEY, poolMintKey, payer.publicKey);
    bonfidaFeeInstruction ? instructions.push(bonfidaFeeInstruction) : null;
    let [bonfidaBuyAndBurnKey, bonfidaBNBInstruction,] = await utils_1.findAndCreateAssociatedAccount(web3_js_1.SystemProgram.programId, connection, main_1.BONFIDA_BNB_KEY, poolMintKey, payer.publicKey);
    bonfidaBNBInstruction ? instructions.push(bonfidaBNBInstruction) : null;
    // @ts-ignore
    console.log(poolTokenAmount, new utils_1.Numberu64(1000000 * poolTokenAmount));
    // Do the effective deposit
    console.log('Execute Buy in');
    let depositTxInstruction = instructions_1.depositInstruction(spl_token_1.TOKEN_PROGRAM_ID, main_1.BONFIDABOT_PROGRAM_ID, sigProviderFeeReceiverKey, bonfidaFeeReceiverKey, bonfidaBuyAndBurnKey, poolMintKey, poolKey, poolAssetKeys, targetPoolTokenKey, sourceOwner.publicKey, sourceAssetKeys, [poolSeed], 
    // @ts-ignore
    new utils_1.Numberu64(1000000 * poolTokenAmount));
    instructions.push(depositTxInstruction);
    console.log(await utils_1.signAndSendTransactionInstructions(connection, [sourceOwner], payer, instructions));
}
exports.singleTokenDeposit = singleTokenDeposit;
/**
 * Returns the seeds of the pools managed by the given signal provider.
 * Returns all poolseeds for the current BonfidaBot program if no signal provider was given.
 *
 * @param connection
 * @param signalProviderKey
 */
async function getPoolsSeedsBySigProvider(connection, signalProviderKey) {
    const filter = [];
    // @ts-ignore
    const resp = await connection._rpcRequest('getProgramAccounts', [
        main_1.BONFIDABOT_PROGRAM_ID.toBase58(),
        {
            commitment: connection.commitment,
            filter,
            encoding: 'base64',
        },
    ]);
    if (resp.error) {
        throw new Error(resp.error.message);
    }
    let poolSeeds = [];
    for (var account of resp.result) {
        let data = Buffer.from(account['account']['data'][0], 'base64');
        if (data.length < state_1.PoolHeader.LEN) {
            continue;
        }
        if (!signalProviderKey ||
            new web3_js_1.PublicKey(data.slice(64, 96)).equals(signalProviderKey)) {
            poolSeeds.push(data.slice(32, 64));
        }
    }
    return poolSeeds;
}
exports.getPoolsSeedsBySigProvider = getPoolsSeedsBySigProvider;
// Returns the pool token mint given a pool seed
const getPoolTokenMintFromSeed = async (poolSeed) => {
    let array_one = new Uint8Array(1);
    array_one[0] = 1;
    let poolMintKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed, array_one], main_1.BONFIDABOT_PROGRAM_ID);
    return poolMintKey;
};
exports.getPoolTokenMintFromSeed = getPoolTokenMintFromSeed;
const parseCreateOrderInstruction = (instruction, poolInfo, sig, cpiInstructions, accounts) => {
    let data = instruction.data;
    let transferInstruction = cpiInstructions.filter(i => {
        let isTokenInstruction = accounts[i.programIdIndex].toBase58() === spl_token_1.TOKEN_PROGRAM_ID.toBase58();
        let isTransferInstruction = instruction.data[0] === 3;
        return isTokenInstruction && isTransferInstruction;
    })[0];
    let transferData = bs58_1.default.decode(transferInstruction.data);
    let transferredAmount = utils_1.Numberu64.fromBuffer(transferData.slice(1, 9)).toNumber();
    let openOrderAccount = instruction.keys[3].pubkey;
    return {
        poolSeed: data.slice(1, 33),
        side: [state_1.OrderSide.Bid, state_1.OrderSide.Ask][data[33]],
        limitPrice: utils_1.Numberu64.fromBuffer(data.slice(34, 42)).toNumber(),
        ratioOfPoolAssetsToTrade: utils_1.Numberu16.fromBuffer(data.slice(42, 44)).toNumber(),
        orderType: [
            state_1.OrderType.Limit,
            state_1.OrderType.ImmediateOrCancel,
            state_1.OrderType.PostOnly,
        ][data[44]],
        clientOrderId: utils_1.Numberu64.fromBuffer(data.slice(45, 53)).toNumber(),
        selfTradeBehavior: [
            state_1.SelfTradeBehavior.DecrementTake,
            state_1.SelfTradeBehavior.CancelProvide,
            state_1.SelfTradeBehavior.AbortTransaction,
        ][data[53]],
        market: poolInfo.authorizedMarkets[utils_1.Numberu16.fromBuffer(data.slice(70, 72)).toNumber()],
        transactionSignature: sig.signature,
        transactionSlot: sig.slot,
        transferredAmount: transferredAmount,
        openOrderAccount: openOrderAccount,
        settledAmount: [],
    };
};
exports.parseCreateOrderInstruction = parseCreateOrderInstruction;
const parseSettleInstruction = (instruction, sig, cpiInstructions, poolAssetMap, accounts) => {
    // console.log("Parsing cpi instructions for settle with %s", instruction.keys[1].pubkey.toBase58());
    // console.log("isTokenInstruction | isTransferInstruction | settlesIntoPool")
    let transferInstructions = cpiInstructions.filter(i => {
        let innerData = bs58_1.default.decode(i.data);
        let isTokenInstruction = accounts[i.programIdIndex].toBase58() === spl_token_1.TOKEN_PROGRAM_ID.toBase58();
        let isTransferInstruction = innerData[0] === 3;
        // Only fetch transfer instructions which transfer assets into the pool (this excludes Serum fees)
        let settlesIntoPool = poolAssetMap.has(instruction.keys[i.accounts[1]].pubkey.toBase58());
        // console.log(`${isTokenInstruction ? 1 : 0}                  | ${isTransferInstruction ? 1 : 0}                     | ${settlesIntoPool ? 1 : 0}              `);
        return isTokenInstruction && isTransferInstruction && settlesIntoPool;
    });
    let transferredAmounts = transferInstructions.map(t => {
        return {
            tokenMint: poolAssetMap.get(instruction.keys[t.accounts[1]].pubkey.toBase58()),
            amount: utils_1.Numberu64.fromBuffer(bs58_1.default.decode(t.data).slice(1, 9)).toNumber(),
        };
    });
    if (transferredAmounts.length === 0) {
        console.log(`Empty settle for ${instruction.keys[1].pubkey.toBase58()}`);
        // Settle instruction did not settle any funds
        return undefined;
    }
    let market = instruction.keys[0].pubkey;
    let openOrderAccount = instruction.keys[1].pubkey;
    return {
        openOrderAccount: openOrderAccount,
        transferredAmounts: transferredAmounts,
        market: market,
        transactionSlot: sig.slot,
    };
};
exports.parseSettleInstruction = parseSettleInstruction;
const getPoolOrdersInfosFromSignature = async (connection, poolInfo, poolAssetMap, sig) => {
    let t = await connection.getConfirmedTransaction(sig.signature);
    let parsed_t = await connection.getParsedConfirmedTransaction(sig.signature);
    let accounts = parsed_t === null || parsed_t === void 0 ? void 0 : parsed_t.transaction.message.accountKeys.map(a => a.pubkey);
    if ((t === null || t === void 0 ? void 0 : t.transaction) === undefined) {
        console.log('Could not retrieve transaction %s', sig.signature);
        return undefined;
    }
    let x = t === null || t === void 0 ? void 0 : t.transaction.instructions.map((i, idx) => {
        var _a, _b, _c;
        if (i.programId.toBase58() === main_1.BONFIDABOT_PROGRAM_ID.toBase58() &&
            (i.data[0] == 3 || i.data[0] == 5)) {
            let innerInstructions = (_c = (_b = (_a = t === null || t === void 0 ? void 0 : t.meta) === null || _a === void 0 ? void 0 : _a.innerInstructions) === null || _b === void 0 ? void 0 : _b.filter(x => {
                // console.log("Comparing %s, %s", x.index, idx);
                return x.index === idx;
            })[0]) === null || _c === void 0 ? void 0 : _c.instructions;
            if (!innerInstructions) {
                // This means that the createOrder or settle instruction had no effect.
                // console.log("Instruction has no effect within transaction %s", bs58.encode(t?.transaction.signature as Buffer));
                return undefined;
            }
            if (i.data[0] == 3) {
                // console.log("Found createOrder");
                return {
                    type: 'createOrder',
                    info: exports.parseCreateOrderInstruction(i, poolInfo, sig, innerInstructions, accounts),
                };
            }
            else {
                let info = exports.parseSettleInstruction(i, sig, innerInstructions, poolAssetMap, accounts);
                if (info) {
                    return {
                        type: 'settle',
                        info: info,
                    };
                }
            }
        }
    });
    return x === null || x === void 0 ? void 0 : x.filter(o => o);
};
exports.getPoolOrdersInfosFromSignature = getPoolOrdersInfosFromSignature;
const getPoolOrderInfos = async (connection, poolSeed, n) => {
    // TODO: this will return less than n orders if the n orders aren't contained within the last 1000 pool transactions
    // TODO: this doesn't track what portion of the order is actually matched.
    // TODO: this only works as long as only IOC orders are supported.
    // TODO: this only works as long as the number of pending orders never exceeds 1 (orders are settled before creating new orders)
    let poolInfo = await fetchPoolInfo(connection, poolSeed);
    let poolAssetMap = new Map();
    (await Promise.all(poolInfo.assetMintkeys.map(async (a) => {
        const v = await utils_1.findAssociatedTokenAddress(poolInfo.address, a);
        return [v.toBase58(), a.toBase58()];
    }))).forEach(v => {
        poolAssetMap.set(v[0], v[1]);
    });
    console.log('Pool address: %s', poolInfo.address.toBase58());
    let confirmedsignatures = await connection.getConfirmedSignaturesForAddress2(poolInfo.address);
    console.log('Confirmed signatures retrieved: %s', confirmedsignatures.length);
    let infos = (await Promise.all(confirmedsignatures.map(s => exports.getPoolOrdersInfosFromSignature(connection, poolInfo, poolAssetMap, s)))).filter(o => o).flat();
    let openOrderAccounts = new Set(infos.map(o => o.info.openOrderAccount.toBase58()));
    for (const openOrderAccount of openOrderAccounts) {
        let history = infos
            .filter(i => i.info.openOrderAccount.toBase58() == openOrderAccount)
            .reverse();
        // console.log(`Open order Account : ${openOrderAccount}`);
        // console.log(`${history.length} transactions`);
        // let sorted_history = history.sort((a, b) => {return a.info.transactionSlot - b.info.transactionSlot});
        // console.log(sorted_history[0]===history[0])
        let firstCreateOrder = history.findIndex(o => o.type === 'createOrder');
        history = history.slice(firstCreateOrder);
        let settleInstructions = history
            .filter(o => o.type === 'settle')
            .map(o => o.info)
            .reverse();
        let createOrderInstructions = history.map(o => o.info);
        createOrderInstructions.forEach(o => {
            let settleInstruction = settleInstructions.pop();
            if (settleInstruction) {
                o.settledAmount = settleInstruction.transferredAmounts;
            }
            return o;
        });
    }
    let createOrderInstructions = infos
        .filter(o => o.type === 'createOrder')
        .map(o => o.info);
    let infos_to_return = createOrderInstructions.slice(0, n);
    let markets = new Map();
    for (const i of infos_to_return) {
        let key = i.market.toBase58();
        if (!markets.has(key)) {
            markets.set(key, await utils_1.getMarketData(connection, i.market));
        }
    }
    let tokenDecimals = new Map();
    for (const [_, m] of markets) {
        for (const mintKey of [m.coinMintKey.toBase58(), m.pcMintKey.toBase58()]) {
            if (!tokenDecimals.has(mintKey)) {
                tokenDecimals.set(mintKey, await market_1.getMintDecimals(connection, m.coinMintKey));
            }
        }
    }
    infos_to_return = infos_to_return.map(i => {
        let marketData = markets.get(i.market.toBase58());
        let limitPrice = (i.limitPrice * marketData.pcLotSize.toNumber()) /
            marketData.coinLotSize.toNumber();
        i.limitPrice = limitPrice;
        let transferredMint = [marketData.pcMintKey, marketData.coinMintKey][i.side];
        i.transferredAmount =
            i.transferredAmount /
                10 ** tokenDecimals.get(transferredMint.toBase58());
        i.settledAmount.map(a => {
            a.amount = a.amount / 10 ** tokenDecimals.get(a.tokenMint);
            return a;
        });
        return i;
    });
    return infos_to_return;
};
exports.getPoolOrderInfos = getPoolOrderInfos;
async function getTotalValue(connection) {
    let poolSeeds = await getPoolsSeedsBySigProvider(connection);
    let totalBalances = new Map();
    console.log("Fetching Balances...");
    // console.log(poolSeeds.map(s => base58.encode(s)));
    for (let seed of poolSeeds) {
        let poolBalance;
        try {
            poolBalance = (await fetchPoolBalances(connection, seed))[1];
        }
        catch {
            console.log("Skipping", bs58_2.default.encode(seed));
            continue;
        }
        for (let i = 0; i < poolBalance.length; i++) {
            let mintString = poolBalance[i]["mint"];
            let b = poolBalance[i]["tokenAmount"]["uiAmount"];
            if (totalBalances.has(mintString)) {
                let tb = totalBalances.get(mintString);
                totalBalances.set(mintString, tb + b);
            }
            else {
                totalBalances.set(mintString, b);
            }
        }
    }
    console.log("Found", poolSeeds.length, "Pools");
    console.log("Adding it up...");
    let total_usdc_val = 0;
    for (let mint of totalBalances.keys()) {
        let tokenSymbol;
        try {
            tokenSymbol =
                serum_1.TOKEN_MINTS[serum_1.TOKEN_MINTS.map(t => t.address.toString()).indexOf(mint)].name;
        }
        catch {
            console.log("Could not find symbol for market:", mint, "Amount: ", totalBalances.get(mint));
            continue;
        }
        if (tokenSymbol === 'USDC') {
            let usdcAmount = totalBalances.get(mint);
            console.log("Added ", usdcAmount, "for USDC");
            total_usdc_val += usdcAmount;
            continue;
        }
        let pairSymbol = tokenSymbol.concat('/USDC');
        let marketInfo = serum_1.MARKETS[serum_1.MARKETS.map(m => {
            return m.name;
        }).lastIndexOf(pairSymbol)];
        if (marketInfo.deprecated) {
            console.log("Warning:", pairSymbol, "is deprecated at address", mint);
        }
        let [_, midPriceUSDC] = await utils_1.getMidPrice(connection, marketInfo.address);
        let amount = totalBalances.get(mint) * midPriceUSDC;
        console.log("Added ", amount, "for", pairSymbol);
        total_usdc_val += amount;
    }
    console.log("Found ", total_usdc_val, " of USDC in pools today.");
    return total_usdc_val;
}
exports.getTotalValue = getTotalValue;
async function getTotalNbTransactions(connection) {
    let poolSeeds = await getPoolsSeedsBySigProvider(connection);
    let totalBalances = new Map();
    console.log("Fetching Nb of transactions for pools...");
    let exceeding_pools = [];
    let total = 0;
    for (let seed of poolSeeds) {
        try {
            let incr = (await exports.getPoolOrderInfos(connection, seed, 1000)).length;
            if (incr = 1000) {
                exceeding_pools.push(bs58_2.default.encode(seed));
            }
            total += incr;
        }
        catch {
            console.log("Skipping", bs58_2.default.encode(seed));
            continue;
        }
    }
    return [total, exceeding_pools];
}
exports.getTotalNbTransactions = getTotalNbTransactions;
//# sourceMappingURL=secondary_bindings.js.map